import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";

import { getCurrentMeet, getScreenMedia, getFederationConfig } from "selectors";
import { getLifterAwardsWeightClassDoc } from "util/lifterHelper";
import FixedHeightWrapper from "app/meets/FixedHeightWrapper";
import ResultsTable from "./ResultsTable";

import "./ResultsIndex.scss";

class ResultsIndex extends Component {
  constructor(props) {
    super(props);
    this.state = {
      forecasted: false,
    };
  }

  setForecasted = () => {
    this.setState({ forecasted: !this.state.forecasted });
  };

  render() {
    const { meet, media, openDonateModal } = this.props;

    const divisions = _.filter(meet.divisions, (division) => {
      return _.find(meet.lifters, (lifter) => {
        return _.find(lifter.divisions, { divisionId: division._id });
      });
    });

    const divisionsAndWeightClasses = _.map(divisions, (division) => {
      const weightClasses = _.filter(division.weightClasses, (wc) => {
        return _.find(meet.lifters, (lifter) => {
          return _.find(lifter.divisions, (ld) => {
            return (
              getLifterAwardsWeightClassDoc(meet, lifter, ld)._id === wc._id
            );
          });
        });
      });
      return { ...division, weightClasses };
    });

    return (
      <FixedHeightWrapper>
        <div className="results-index">
          <ResultsTable
            meet={meet}
            divisions={divisionsAndWeightClasses}
            media={media}
            setForecasted={this.setForecasted}
            forecasted={this.state.forecasted}
            showButtons
            openDonateModal={openDonateModal}
            federationConfig={this.props.federationConfig}
          />
        </div>
      </FixedHeightWrapper>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    meet: getCurrentMeet(state, props),
    media: getScreenMedia(state, props),
    federationConfig: getFederationConfig(state, props),
  };
};

const actions = {};

export default connect(mapStateToProps, actions)(ResultsIndex);
